export const betOnActionFreeModeEnabled: boolean = false;
